module.exports = __webpack_public_path__ + "img/1F508.bb86525b.svg";